import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetDocumentTypesCommand extends IRequestCommand<
  IGetDocumentTypesParameters,
  ErrorDetails,
  IGetDocumentTypesResponse
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'data/documents/{module}';

  public override setParameters(parameters: IGetDocumentTypesParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{module}',
      parameters.module ? parameters.module : ''
    );
  }
}

export interface IGetDocumentTypesParameters extends ICommandParameters {
  module: string;
}

export interface IGetDocumentTypesResponse extends ICommandResponse {}
